import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryString, getQueryStringToSnakeCase, objectKeysCamelToSnakeCase } from 'core/utils';
import { IUom, IUomConversion } from 'parts/types';

export const getManyUoms = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IUom>> => {
  const { data } = await partfinitiClient.get(
    `/parts/uom/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<IUom>(data.uoms, data.total_count);
};

export const getManyUomConversions = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IUomConversion>> => {
  const { data } = await partfinitiClient.get(
    `/uom/part-uom-conversion-list/conversions?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IUomConversion>(data.data, data.recordsFiltered);
};

export const upsertUomConversion = async (data: { partUomConversion: Partial<IUomConversion> }) =>
  partfinitiClient.postForm('/uom/part-uom-conversion-edit/save', data);

export const removeUomConversions = async (ids: number[]) =>
  partfinitiClient.postForm('/uom/part-uom-conversion-edit/remove', { ids });
